import { render, staticRenderFns } from "./sales-graphic.vue?vue&type=template&id=51e4f7d1&scoped=true&"
import script from "./sales-graphic.vue?vue&type=script&lang=js&"
export * from "./sales-graphic.vue?vue&type=script&lang=js&"
import style0 from "./sales-graphic.vue?vue&type=style&index=0&id=51e4f7d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e4f7d1",
  null
  
)

export default component.exports